import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function Book() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F5] to-white">
      <Navigation />
      
      <main className="pt-32 pb-20">
        <div className="max-w-6xl mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center">
                <i className="ri-book-open-line text-3xl text-[#D4A5A5]"></i>
              </div>
            </div>
            <h1 className="text-4xl font-serif mb-6 text-[#2C2C2C]">書籍案内</h1>
            <div className="w-32 h-px bg-[#D4A5A5] mx-auto"></div>
          </div>

          {/* Book Content */}
          <div className="bg-white rounded-3xl shadow-lg p-12">
            <div className="flex flex-col md:flex-row gap-12 items-start">
              {/* Book Cover */}
              <div className="w-full md:w-2/5 flex-shrink-0">
                <div className="relative">
                  <div className="absolute -inset-4 opacity-20">
                    <div className="w-full h-full border-2 border-[#D4A5A5] rounded-2xl"></div>
                  </div>
                  <img
                    src="https://public.readdy.ai/ai/img_res/0c9388ac9a7cf41644e2f04ea98670ba.jpg"
                    alt="書籍カバー"
                    className="w-full rounded-xl shadow-xl relative z-10 object-cover"
                    style={{ height: '600px' }}
                  />
                </div>
              </div>

              {/* Book Information */}
              <div className="flex-1">
                <h2 className="text-4xl font-serif font-bold mb-4 text-[#2C2C2C]">
                  医師との会話が続く人の<br />戦略ノート
                </h2>
                <p className="text-xl text-[#888888] mb-8">著：ジェイゾロフト瞳</p>

                <div className="space-y-6 text-xl leading-loose text-[#4A4A4A] mb-10">
                  <p>
                    医師・高収入男性とのマッチングアプリでのやりとりについて、<br />
                    実際の経験をもとに書いた一冊です。
                  </p>
                  <p>
                    戦略というと大げさに聞こえますが、<br />
                    要するに「相手のことを知る」ということです。
                  </p>
                  <p>
                    それを知った上で話すのと、知らずに話すのとでは、<br />
                    同じ言葉でも届き方が変わります。
                  </p>
                </div>

                <div className="border-t-2 border-[#E8D5D5] pt-8 mb-8">
                  <div className="flex items-baseline gap-4 mb-8">
                    <span className="text-4xl font-bold text-[#C9A0A0]">¥3,980</span>
                    <span className="text-lg text-[#888888]">（電子書籍）</span>
                  </div>
                  
                  <button className="bg-[#B88B8B] text-white px-12 py-5 rounded-full text-lg font-medium hover:bg-[#A67A7A] transition-all shadow-md whitespace-nowrap cursor-pointer">
                    購入する
                  </button>
                </div>

                <div className="bg-[#FFF8F5] rounded-xl p-6">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-information-line text-xl text-[#D4A5A5]"></i>
                    </div>
                    <div className="text-sm text-[#666666] leading-relaxed">
                      <p>Amazon Kindleにて配信中</p>
                      <p className="mt-2">購入後すぐにお読みいただけます</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Content */}
          <div className="mt-12 bg-white rounded-3xl shadow-lg p-10">
            <h3 className="text-2xl font-serif mb-6 text-center text-[#2C2C2C]">こんな内容が書かれています</h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#FFF8F5] rounded-full">
                  <i className="ri-chat-3-line text-3xl text-[#C9A0A0]"></i>
                </div>
                <h4 className="text-lg font-medium mb-3 text-[#2C2C2C]">会話の続け方</h4>
                <p className="text-[#666666] leading-relaxed">
                  3往復で終わらない<br />話題の選び方
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#FFF8F5] rounded-full">
                  <i className="ri-heart-pulse-line text-3xl text-[#C9A0A0]"></i>
                </div>
                <h4 className="text-lg font-medium mb-3 text-[#2C2C2C]">医師の思考パターン</h4>
                <p className="text-[#666666] leading-relaxed">
                  職業的特性を理解する<br />ための視点
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#FFF8F5] rounded-full">
                  <i className="ri-lightbulb-line text-3xl text-[#C9A0A0]"></i>
                </div>
                <h4 className="text-lg font-medium mb-3 text-[#2C2C2C]">実践的なアプローチ</h4>
                <p className="text-[#666666] leading-relaxed">
                  すぐに使える<br />具体的な方法論
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}